export default __webpack_public_path__ + "static/back2-eadb6a0f3c442c84b84d00816e8eb32e.png";